module.exports = __webpack_public_path__ + "img/E - 01.47af0190.png";